import {useQuery} from 'react-query'
import {PropertymanagementEditModalForm} from './PropertymanagementEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getPropertymanagementById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const PropertymanagementEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: propertymanagement,
    error,
  } = useQuery(
    `${QUERIES.TENANTS_LIST}-propertymanagement-${itemIdForUpdate}`,
    () => {
      return getPropertymanagementById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  console.log("1222222222222",propertymanagement)

  if (!itemIdForUpdate) {
    return <PropertymanagementEditModalForm isPropertymanagementLoading={false} propertymanagement={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <PropertymanagementEditModalForm isPropertymanagementLoading={false} propertymanagement={dataresponse} />
  }

  return null
}

export {PropertymanagementEditModalFormWrapper}
